@use "../styles/defaults";

.po_container {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;
    flex-direction: row;
    justify-content: center;
    background: rgba(0, 0, 0, 0.8);
    font-family: Roboto, Arial, Helvetica, sans-serif;

    &.show_po {
        display: flex;
    }

    .personalize_overlay {
        display: block;
        width: 520px;
        max-height: 800px;
        background-color: defaults.$lc-white;
        margin-top: auto;
        margin-bottom: auto;
        overflow-y: auto;
        line-height: 1.5;
        box-sizing: border-box;

        @media only screen and (max-width: defaults.$breakpoint-mobile-iphone12Pro) {
            max-height: initial;
        }

        .po_header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: auto;
            margin-left: 40px;
            margin-right: 40px;
            line-height: 48px;
            margin-top: 15px;
            padding-bottom: 15px;
            border-bottom: 1px solid defaults.$lc-mid-grey;

            .h_title {
                text-transform: uppercase;
                font-size: defaults.$default-header-font-size;
                font-weight: 700;
            }

            .h_cross_icon {
                width: 48px;
                height: 48px;
                cursor: pointer;
                border-radius: 28px;

                svg {
                    width: 48px;
                    height: 48px;
                    fill: defaults.$lc-black;

                    .ring {
                        transition: fill 300ms;
                        fill: defaults.$lc-mid-grey;
                    }
                }

                &:hover svg .ring {
                    fill: defaults.$lc-black;
                }
            }
        }

        .po_body {
            display: flex;
            flex-direction: column;
            margin-top: 30px;

            .banner_short_info {
                margin-left: 40px;
                margin-right: 40px;

                .small_banner {
                    width: 100%;
                    border-radius: 15px;
                    background: url("../img/personal-overlay-image.jpg") no-repeat;
                    height: 160px;
                    background-position: center;
                }

                .short_info {
                    margin-top: 25px;
                    font-size: defaults.$default-label-font-size;
                }
            }

            .link_button {
                display: inline-table;
                min-height: 84px;
                position: relative;
                border-radius: 15px;
                margin-left: 40px;
                margin-right: 40px;
                margin-top: 20px;
                cursor: pointer;
                border: 1px solid defaults.$lc-mid-grey;
                transition: border-color 0.3s;

                .lbtn_title {
                    display: flex;
                    flex-direction: row;
                    font-size: defaults.$default-header-font-size;
                    font-weight: 500;
                    margin-top: 15px;
                    margin-left: 15px;

                    .icon {
                        margin-right: 10px;

                        svg {
                            height: 24px;
                        }
                    }

                    .label {
                        line-height: 24px;
                    }
                }

                .description {
                    font-size: defaults.$default-label-font-size;
                    margin-right: 50px;
                    margin-left: 25px;
                    margin-top: 10px;
                    margin-bottom: 15px;
                }

                .link_arrow {
                    position: absolute;
                    right: 18px;
                    top: 0;
                    bottom: 0;
                    margin-top: auto;
                    margin-bottom: auto;
                    height: 20px;
                }

                &:last-child {
                    margin-bottom: 25px;
                }

                &:hover {
                    border-color: defaults.$lc-black;
                }
            }

            .design_link_button {
                background-color: defaults.$lc-light-grey;

                .description {
                    font-weight: 700;
                }

                .description_bullet {
                    display: flex;
                    flex-direction: row;
                    margin: 0px 50px 0px 25px;
                    font-size: 13px;

                    svg {
                        height: 16px;
                        width: 16px;
                    }

                    .bullet {
                        margin-left: 8px;
                    }

                    &:nth-last-child(1 of .description_bullet) {
                        margin-bottom: 15px;
                    }
                }

                .has_customer_logo {
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 24px;
                    border-radius: 8px;
                    background-color: orange;
                    color: defaults.$lc-white;
                    height: 24px;
                    width: fit-content;
                    padding: 0 8px;
                    margin: 10px 50px 15px 25px;
                }
            }
        }

        .po_footer {
            .close_button {
                display: flex;
                justify-content: center;
                align-items: center;
                color: defaults.$lc-black;
                border: none;
                border-radius: 50px;
                margin: 30px auto 30px 40px;
                padding: 14px 30px 15px 30px;
                font-weight: 500;
                font-size: defaults.$default-label-font-size;
                text-transform: lowercase;
                cursor: pointer;
                transition: background-color 0.3s;

                &:hover {
                    background-color: defaults.$lc-mid-grey;
                }
            }
        }
    }
}
